module.exports = __webpack_public_path__ + "img/北京冷库 (1).9a60a257.jpg";